
export const getPriceByQuantity = (prices, quantity) => {
    if (!prices) {
        return null;
    }
    for (const key of Object.keys(prices)) {
        const priceRange = prices[key];
        if ((priceRange.min == null || quantity >= +priceRange.min) && (priceRange.max == null || quantity <= +priceRange.max)) {
            return priceRange;
        }
    }
};

